import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditNavigationGuard } from 'lib-core-shared';
import { productRouteMap } from '../../app-routing.module';
import { ProductDetailResolver } from '../../resolver/product-data-resolver';
import { ProductCreatePageComponent } from './product-create-page.component';

const customerDetailsRouteName = productRouteMap?.children ? productRouteMap.children[2].fullRouteName: ''
console.log('path', customerDetailsRouteName);
const routes: Routes = customerDetailsRouteName?.length ? [
  { 
    path: `` , 
    component: ProductCreatePageComponent, 
    canActivate: [EditNavigationGuard],
    resolve: {
      productData: ProductDetailResolver,
    }
  },
]: [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProducCreateRoutingModule { }